<template>
  <router-view></router-view>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  mounted() {
    this.getExamQuestions();
  },
  methods: {
    ...mapActions(['getExamQuestions']),
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
